import Index from '@/views/settings/message-templates/index.vue';
import { Roles } from '@common/app.config';

const authMeta = {
  auth: true,
  // No.176: clinic_admin access removed, doctor access granted per customer confirmation
  // (2026-10-12) — see docs/specs/no176-message-template.md (api repo).
  authorize: [Roles.superAdmin, Roles.doctor],
};

export default [
  {
    path: '/message-templates',
    name: 'message-templates',
    component: Index,
    meta: authMeta,
  },
];
